import { ProgrammeUserRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/Collaborate/Collaborate.types';
import { ContractDataItem } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/Contracts/useContractsController';
import { IPredefinedCustomDetail } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/PersonalData/usePersonalDataController';
import { MIP_CREATE_ROUTES } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/useMIPCreateController';
import {
	CurrencyType,
	DataContractTct,
	DataCustomDetailTct,
	GetInvestorDraftInstanceRes,
	GetInvestorDraftStatisticsRes,
} from '@dealstack/shared/lib/generated';
import { useState } from 'react';
import { ILocalPersonalDataCustomDetails } from './PersonalData/PersonalDataTagManagerModal/PersonalDataTagManagerModal.types';

type FormTemplate = {
	id: string;
	fileId: string;
	fileName: string;
	name: string;
	instruction?: string;
	type: DataCustomDetailTct['type'];
	dataType: DataCustomDetailTct['dataType'];
	preFillableFormTemplateId?: string;
	local?: boolean;
};

export interface MIPCreateBackup {
	[MIP_CREATE_ROUTES.GENERAL]?: {
		entityId?: string;
		programmeName?: string;
		investorInstructions?: string;
		currency?: CurrencyType;
	};
	[MIP_CREATE_ROUTES.PERSONAL]?: {
		individualArray: ILocalPersonalDataCustomDetails[];
		vehiclesArray: ILocalPersonalDataCustomDetails[];
		remoteCustomDetails: DataCustomDetailTct[];
		predefinedDetails: IPredefinedCustomDetail[];
	};
	[MIP_CREATE_ROUTES.INVESTORS]?: {
		investors?: GetInvestorDraftInstanceRes[];
		statistics?: GetInvestorDraftStatisticsRes;
	};
	[MIP_CREATE_ROUTES.COLLABORATE]?: {
		userProgrammeList: ProgrammeUserRow[];
	};
	[MIP_CREATE_ROUTES.CONTRACTS]?: {
		contracts?: ContractDataItem[] | null;
		remoteContracts?: DataContractTct[] | null;
	};
	[MIP_CREATE_ROUTES.KYC]?: {
		requestCertifiedCopiesOfDocuments: boolean;
		individualFormsTemplates: FormTemplate[] | null;
		pivFormsTemplates: FormTemplate[] | null;
	};
}

export const useBackupController = () => {
	const [dataBackup, setDataBackup] = useState<MIPCreateBackup>({});

	const updateBackupData = (key: keyof MIPCreateBackup, data: Record<string, unknown>) => {
		setDataBackup((prevState) => ({
			...prevState,
			[key]: { ...prevState[key], ...data },
		}));
	};

	const removeBackupData = (key: keyof MIPCreateBackup) => {
		setDataBackup((prevState) => ({
			...prevState,
			[key]: undefined,
		}));
	};

	return { dataBackup, updateBackupData, removeBackupData };
};
